<button (click)="test()">Social - Share</button>
<button (click)="changeMeta()">change meta</button>